// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3MeyK","left":"StickyBox_left__3ydRh","right":"StickyBox_right__cQCPL"};